@if (canPrint()) {
<!-- slider -->
<div class="carousel-container pos-relative">
    <carousel class="default-swiper swiper-slide-per-view related-product-carousel default-pagination"
              [slidesPerView]="'auto'"
              [scrollbar]="{ draggable: true }"
              [freeMode]="true"
              [navigation]="{
                addIcons:false,
                nextEl: '.related-product-next-' + uid,
                prevEl: '.related-product-prev-' + uid,
                }"
              [style.--pc-slides-ceil]="pcSlidesCeil"
              [style.--pc-slides]="pcSlides"
              [style.--pc-gutter]="pcGutter"
              imageViewRoot
              [gtmList]="{listName : 'Related products', listId : 'related_products'}">
        @if (listing) {
        @for (model of listing.models; track model.id) {
        <ng-template carouselSlide>
            <product [model]="model"
                     [gtmItem]="{position: $index+1, product : model}"></product>
        </ng-template>
        }
        }
    </carousel>

    <!-- navigation buttons-->
    <div class="pos-absolute w-12 z-5 related-product-carousel-buttons"
         [class.hidden]="(listing?.models?.length ?? 0) < pcSlides">
        <button class="swiper-arrow-button pos-absolute inline-flex"
                style="left: -20px"
                [ngClass]="'related-product-prev-' + uid"
                aria-label="Previous slide"
                type="button">
            <i class="icon-chevron-left col-w"
               aria-hidden="true"></i>
        </button>
        <button class="swiper-arrow-button pos-absolute  inline-flex"
                [ngClass]="'related-product-next-' + uid"
                style="right: -20px"
                aria-label="Next slide"
                type="button">
            <i class="icon-chevron-right col-w"
               aria-hidden="true"></i>
        </button>
    </div>
</div>
}